// Nice, readable colors on a dark background.
export const CHART_COLORS = {
  // series
  cam41: "#60A5FA",       // sky-400
  cheltenham: "#34D399",  // emerald-400
  chel: "#34D399",        // alias for legacy references
  pool: "#FBBF24",        // amber-400

  // scaffolding
  grid: "#233042",
  axis: "#8AA0BD",
  legend: "#BCD1F1",

  // tooltip
  tooltipBg: "#0f141c",
  tooltipBorder: "#1f2834",
  tooltipCursorFill: "rgba(255,255,255,0.06)",
};
